const getEntries = <T extends string, U>(
  record: Partial<Record<T, U>>
): [T, U][] => {
  return Object.entries(record) as [T, U][];
};

const getKeys = <T extends string>(
  record: Partial<Record<T, unknown>>
): T[] => {
  return Object.keys(record) as T[];
};

const filterNullish = <T extends string, U>(
  record: Partial<Record<T, U>>
): Partial<Record<T, NonNullable<U>>> => {
  return Object.fromEntries(
    Object.entries(record).filter((entry): entry is [T, NonNullable<U>] => {
      return entry[1] !== undefined && entry[1] !== null;
    })
  ) as Partial<Record<T, NonNullable<U>>>;
};

export { getEntries, getKeys, filterNullish };
